import { lazy } from 'react';
import { ROUTE_PATHS } from './route';

const Home = lazy(() => import('../Pages/Home.js'));

//Auth Routes
const Signin = lazy(()=> import('../Pages/Auth/Login.jsx'))
const Signup = lazy(()=>import('../Pages/Auth/Signup.jsx'))
const Signout = lazy(()=>import('../Pages/Auth/Signout.jsx'))
const Verify_Otp = lazy(()=>import('../Pages/Auth/OTPVerification.jsx'))
const AuthCallback = lazy(()=>import('../Pages/Auth/AuthCallback.jsx'))

const Dashboard = lazy(()=> import('../Pages/Dashboard/OverviewPage.jsx'))
const FootPrintTracker = lazy(()=> import('../Pages/Dashboard/FootPrintTracker.jsx'))
const AIInsights = lazy(()=> import('../Pages/Dashboard/AIInsights.jsx'))
const SupplyChainFlow = lazy(()=> import('../Pages/Dashboard/SupplyChainFlow.jsx'))
const Portfolio = lazy(()=> import('../Pages/Dashboard/Portfolio.jsx'))
const InvestmentHub = lazy(()=> import('../Pages/Dashboard/InvestmentHub.jsx'))


const About = lazy(()=> import('../Pages/About.jsx'))
const Contact = lazy(()=> import('../Pages/ContactUs.jsx'))
const Faq = lazy(()=> import('../Pages/FAQ.jsx'))

//SCMART
const Agriculture = lazy(()=> import('../Pages/Scmart/Agriculture.jsx'))
const Forestry = lazy(()=> import('../Pages/Scmart/Forestry.jsx'))
const IndustrialProcess = lazy(()=> import('../Pages/Scmart/IndustrialProcess.jsx'))
const PlasticAlternatives = lazy(()=> import('../Pages/Scmart/PlasticAlternatives.jsx'))
const RenewableEnergy = lazy(()=> import('../Pages/Scmart/RenewableEnergy.jsx'))
const WasteManagement = lazy(()=> import('../Pages/Scmart/WasteManagement.jsx'))

//invest 
// const Invest = lazy(()=> import('../Pages/Invest/Invest.jsx'))
const SCCredit = lazy(()=> import('../Pages/Invest/SCCredits.jsx'))
const Transactions = lazy(()=> import('../Pages/Invest/Transactions.jsx'))
const Retirements = lazy(()=> import('../Pages/Invest/Retirements.jsx'))

//Analysis
// const Analysis = lazy(()=> import('../Pages/Analysis/Analysis.jsx'))
const Technical = lazy(()=> import('../Pages/Analysis/Technical.jsx'))
const Reports = lazy(()=> import('../Pages/Analysis/Reports.jsx'))
const News = lazy(()=> import('../Pages/Analysis/News.jsx'))

//Platform
const MobileApp = lazy(()=> import('../Pages/Platforms/MobileApp.jsx'))
const AnalysisPlatform = lazy(()=> import('../Pages/Platforms/Analysis.jsx'))

//Footer
const TermsAndConditions = lazy(()=> import('../Pages/TermsAndConditions.jsx'))
const PrivacyPolicy = lazy(()=> import('../Pages/PrivacyPolicy.jsx'))

//Cookie Settings
const DataSecurity = lazy(()=> import('../Pages/DataSecurity.jsx'))
const CookiePolicy = lazy(()=> import('../Pages/CookiePolicy.jsx'))
const InformationSecurity = lazy(()=> import('../Pages/InformationSecurity.jsx'))

// Public pages
export const publicRoutes = [
   { path: ROUTE_PATHS.HOME, element: Home },
   {path:ROUTE_PATHS.SIGNUP,element:Signup},
   {path:ROUTE_PATHS.ABOUT,element:About},
   {path:ROUTE_PATHS.CONTACT,element:Contact},
   {path:ROUTE_PATHS.FAQ,element:Faq},
   {path:ROUTE_PATHS.AuthCallback,element:AuthCallback},
   //SCMART
   {path:ROUTE_PATHS.AGRICULTURE,element:Agriculture},
   {path:ROUTE_PATHS.FORESTRY,element:Forestry},
   {path:ROUTE_PATHS.INDUSTRIAL_PROCESS,element:IndustrialProcess},
   {path:ROUTE_PATHS.PLASTIC_ALTERNATIVES,element:PlasticAlternatives},
   {path:ROUTE_PATHS.RENEWABLE_ENERGY,element:RenewableEnergy},
   {path:ROUTE_PATHS.WASTE_MANAGEMENT,element:WasteManagement},

   //Invest
   // {path:ROUTE_PATHS.INVEST,element:Invest},
   {path:ROUTE_PATHS.SCCredit,element:SCCredit},
   {path:ROUTE_PATHS.Transactions,element:Transactions},
   {path:ROUTE_PATHS.Retirements,element:Retirements},

   //Analysis
   // {path:ROUTE_PATHS.ANALYSIS,element:Analysis},
   {path:ROUTE_PATHS.Technical,element:Technical},
   {path:ROUTE_PATHS.Reports,element:Reports},
   {path:ROUTE_PATHS.News,element:News},

   //Platform
   {path:ROUTE_PATHS.MobileApp,element:MobileApp},
   {path:ROUTE_PATHS.AnalysisPlatform,element:AnalysisPlatform},

   //Footer
   {path:ROUTE_PATHS.TermsAndConditions,element:TermsAndConditions},
   {path:ROUTE_PATHS.PrivacyPolicy,element:PrivacyPolicy},

   //Cookie Settings
   {path:ROUTE_PATHS.DataSecurity,element:DataSecurity},
   {path:ROUTE_PATHS.CookiePolicy,element:CookiePolicy},
   {path:ROUTE_PATHS.InformationSecurity,element:InformationSecurity},

];
export const authRoutes = [
   {path:ROUTE_PATHS.SIGNIN,element:Signin},
   {path:ROUTE_PATHS.SIGNOUT,element:Signout},
   {path:ROUTE_PATHS.VERIFY_OTP,element:Verify_Otp}
 ];
export const protectedRoutes = [
   {path:ROUTE_PATHS.DASHBOARD,element:Dashboard},
   {path:ROUTE_PATHS.FOOTPRINT,element:FootPrintTracker},
   {path:ROUTE_PATHS.AIINSIGHTS,element:AIInsights},
   {path:ROUTE_PATHS.SUPPLYCHAINFLOW,element:SupplyChainFlow},
   {path:ROUTE_PATHS.PORTFOLIO,element:Portfolio},
   {path:ROUTE_PATHS.INVESTMENTHUB,element:InvestmentHub},
];

export const NotFound = () => (
   <div className="flex items-center justify-center min-h-screen md:text-xl lg:text-3xl">
      404 | Not Found
   </div>
);